import React from 'react';
import { Box, Grid, Typography } from "@mui/material";
import {
    InfoOutlined,
    CurrencyRupeeOutlined,
    PersonOutlineOutlined,
    PhoneAndroidOutlined,
    StorefrontOutlined,
    AccessTime,
} from "@mui/icons-material";
import { useDeliveryDetailContext } from "contexts/DeliveryDetailContext";
import InformationTile from "components/Shared/InformationTile";
import { localizeDateTimeShort } from "utils/dateFormats";

export const DeliveryPaymentDetailTab = () => {
    const { deliveryDetail } = useDeliveryDetailContext();

    const hasPaymentDetails = deliveryDetail?.paymentDetails;

    if (!hasPaymentDetails) {
        return (
            <Box padding={3}>
                <Typography variant="h6" color="textSecondary" textAlign="center">
                    No payment details available
                </Typography>
            </Box>
        );
    }

    return (
        <Box padding={3}>
            <Grid container spacing={4}>
                <Grid item xs={3}>
                    <InformationTile
                        icon={() => <InfoOutlined color="primary" />}
                        title="Transaction ID"
                        subtitle={deliveryDetail?.paymentDetails?.nQrTxnId || "N/A"}
                    />
                </Grid>
                <Grid item xs={3}>
                    <InformationTile
                        icon={() => <CurrencyRupeeOutlined color="primary" />}
                        title="Amount"
                        subtitle={deliveryDetail?.paymentDetails?.amount || "N/A"}
                    />
                </Grid>
                <Grid item xs={3}>
                    <InformationTile
                        icon={() => <PersonOutlineOutlined color="primary" />}
                        title="Payer Name"
                        subtitle={deliveryDetail?.paymentDetails?.payerName || "N/A"}
                    />
                </Grid>
                <Grid item xs={3}>
                    <InformationTile
                        icon={() => <PhoneAndroidOutlined color="primary" />}
                        title="Payer Phone"
                        subtitle={deliveryDetail?.paymentDetails?.payerMobileNumber || "N/A"}
                    />
                </Grid>
                <Grid item xs={3}>
                    <InformationTile
                        icon={() => <StorefrontOutlined color="primary" />}
                        title="Merchant Name"
                        subtitle={deliveryDetail?.paymentDetails?.merchantName || "N/A"}
                    />
                </Grid>
                <Grid item xs={3}>
                    <InformationTile
                        icon={() => <StorefrontOutlined color="primary" />}
                        title="Merchant Bill Number"
                        subtitle={deliveryDetail?.paymentDetails?.merchantBillNo || "N/A"}
                    />
                </Grid>
                <Grid item xs={3}>
                    <InformationTile
                        icon={() => <AccessTime color="primary" />}
                        title="Payment Date"
                        subtitle={
                            deliveryDetail?.paymentDetails?.paymentDate
                                ? localizeDateTimeShort(deliveryDetail.paymentDetails.paymentDate)
                                : "N/A"
                        }
                    />
                </Grid>
            </Grid>
        </Box>
    );
};